import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	exitTourButtonLabel: {
		id: 'servicedesk-itsm-onboarding-common.common.itsm-spotlight-card.exit-tour-button-label',
		defaultMessage: 'Exit tour',
		description: 'Label given to the close button inside itsm spotlight cards',
	},
});
